import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise';
import { composeWithDevTools } from 'redux-devtools-extension';

import RootReducer from './reducers';
import App from './components/App';
// Styles
// Import Font Awesome Icons Set
import './contents/css/index.css';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import AccessProvider from './contexts/AccessProvider';

const store = createStore(
  RootReducer,
  composeWithDevTools(applyMiddleware(promiseMiddleware))
);

render(
  <Provider store={store}>
    <AccessProvider>
      <App />
    </AccessProvider>
  </Provider>,
  document.getElementById('root')
);
